// /* eslint-disable jsx-a11y/anchor-is-valid */
import { enIN } from 'date-fns/locale';
import { Field, Formik, Form as FormikForm } from 'formik';
import React, { useState } from 'react';
import { Button, Col, Dropdown, Form, Row } from 'react-bootstrap';
import { registerLocale } from 'react-datepicker';
import {
  OrderTableFilterInitialState,
  TrayFilterInitialState,
} from '../../../../core/initialState/filter-initial-state';
import { ITrayFilter } from '../../../../models/ITrayFilter';
import FormikFormDatePicker from '../../../../shared-components/FormikFormHandlers/FormikFormDatePicker';
import FormikFormInput from '../../../../shared-components/FormikFormHandlers/FormikFormInput';
import FormLoader from '../../../../shared-components/FormLoader/FormLoader';
import Label from '../../../../shared-components/label/label';
import {
  ClearFilterIcon,
  FilterIcon,
} from '../../../../shared-components/svgs/svgs';
import { formatMessage } from '../../../../translations/format-message';
import validAllowedCharacters from '../../../../constants/valid-character-password';
import validCharacters from '../../../../constants/valid-characters';
import { OrderTableFilterValidationSchema } from '../../../../shared-components/FormikFormHandlers/FormikValidationSchema';
import { IOrderTableFilter } from '../../../../models/IOrderTableFilter';
import FormikFormSelect from '../../../../shared-components/FormikFormHandlers/FormikFormSelect';
import { IProcessList } from '../../../../models/response/IProcessResponse';
import { IOption } from '../../../../models/ICommon';

registerLocale('en-IN', enIN);

interface IProps {
  initialValues: IOrderTableFilter;
  id: number;
  submitHandler: (data: any) => void;
  filterParmas: (data: any, isfilterCleard: boolean) => void;
  onModalClosed: () => void;
  isLoading: boolean;
  isDisable: boolean;
  isFilterCleared: boolean;
  isFilterApplied: boolean;
  setIsFilterApplied: (status: boolean) => void;
  allFactoryProcess: IOption[];
}
const FilterComponent = (props: IProps) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const handleToggle = (isOpen: boolean, resetForm: () => void) => {
    if (!isOpen) {
      resetForm();
    }
    setShowDropdown(isOpen);
  };

  function getLocalISODate(isoDate: Date) {
    return (
      isoDate.getFullYear() +
      '-' +
      String(isoDate.getMonth() + 1).padStart(2, '0') +
      '-' +
      String(isoDate.getDate()).padStart(2, '0') +
      'T' +
      String(isoDate.getHours()).padStart(2, '0') +
      ':' +
      String(isoDate.getMinutes()).padStart(2, '0') +
      ':' +
      String(isoDate.getSeconds()).padStart(2, '0')
    );
  }

  return (
    <React.Fragment>
      <Formik
        initialValues={props.initialValues}
        enableReinitialize
        validationSchema={OrderTableFilterValidationSchema}
        validateOnBlur={false}
        onSubmit={async (
          values: IOrderTableFilter,
          { resetForm, setFieldValue }
        ) => {
          if (values.CustomerDueDate) {
            values = {
              ...values,
              CustomerDueDate: `${getLocalISODate(
                new Date(values.CustomerDueDate)
              ).slice(0, 10)}`,
            };
          }

          if (values.PlanedDueDate) {
            values = {
              ...values,
              PlanedDueDate: `'${getLocalISODate(
                new Date(values.PlanedDueDate)
              ).slice(0, 10)}'`,
            };
          }
          props.submitHandler(values);
          setShowDropdown(false);
          props.setIsFilterApplied(true);
        }}
      >
        {({ dirty, resetForm, setFieldValue, values }) => {
          return (
            <Dropdown
              className={`Filter-DID ${props.isDisable ? 'disabled-li' : ''}`}
              show={showDropdown}
              onToggle={(isOpen) => handleToggle(isOpen, resetForm)}
            >
              <Dropdown.Toggle
                className={`btn btn-light ${props.isFilterApplied ? 'btn-filter-disable' : 'btn-filter'}`}
                aria-expanded="false"
                title={formatMessage('filter')}
              >
                {/* <FilterIcon isDisable={props.isDisable} /> */}
                {!props.isFilterApplied ? (
                  <FilterIcon isDisable={props.isDisable} />
                ) : (
                  <ClearFilterIcon
                    onClick={(e) => {
                      // props.filterParmas(
                      //   { ...OrderTableFilterInitialState },
                      //   true
                      // );
                      resetForm();
                      setShowDropdown(true);
                      // props.setIsFilterApplied(!props.isFilterApplied);
                    }}
                  />
                )}
              </Dropdown.Toggle>
              <FormikForm className="user-form">
                {props.isLoading ? (
                  <FormLoader loading={props.isLoading} />
                ) : null}
                <Dropdown.Menu className="filter-menu order-filter">
                  <Dropdown.ItemText className="p-0">
                    <Form.Group controlId="dateRange">
                      <div
                        className={`filter-header border-bottom p-3 px-4 ${props.isFilterCleared ? '' : ''}`}
                      >
                        <h4>
                          {formatMessage('filter')}
                          <a
                            className="clear-filter float-end"
                            onClick={() => {
                              resetForm();
                              setShowDropdown(false);
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              fill="currentColor"
                              className="bi bi-x"
                              viewBox="0 0 16 16"
                            >
                              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"></path>
                            </svg>
                          </a>
                        </h4>
                      </div>
                      <Row className="p-3 px-4">
                        <Col md={4}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="tray_id"
                              htmlFor="TrayId"
                            />
                            <Field
                              data-testid="TrayId"
                              className="form-control"
                              name="TrayId"
                              autoComplete="off"
                              placeholder=""
                              as={FormikFormInput}
                              validcharacter={validCharacters}
                            />
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="order_id"
                              htmlFor="OrderId"
                            />
                            <Field
                              data-testid="OrderId"
                              className="form-control"
                              name="OrderId"
                              autoComplete="off"
                              placeholder=""
                              as={FormikFormInput}
                              validcharacter={validCharacters}
                            />
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="customer_due_date"
                              htmlFor="CustomerDueDate"
                            />
                            <Field
                              data-testid="CustomerDueDate"
                              className="form-control"
                              name="CustomerDueDate"
                              autoComplete="off"
                              placeholder=""
                              as={FormikFormDatePicker}
                              isClearable={values.CustomerDueDate}
                              // validcharacter={validCharacters}
                              // minDate={new Date()}
                            />
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="end_user_order_id_short"
                              htmlFor="EUOrderNo"
                            />
                            <Field
                              data-testid="EUOrderNo"
                              className="form-control"
                              name="EUOrderNo"
                              autoComplete="off"
                              placeholder=""
                              as={FormikFormInput}
                              validcharacter={validCharacters}
                            />
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="product_id"
                              htmlFor="ProductId"
                            />
                            <Field
                              data-testid="ProductId"
                              className="form-control"
                              name="ProductId"
                              autoComplete="off"
                              placeholder=""
                              as={FormikFormInput}
                              validcharacter={validCharacters}
                            />
                          </div>
                        </Col>{' '}
                        <Col md={4}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="end_user_name"
                              htmlFor="EndUserName"
                            />
                            <Field
                              data-testid="EndUserName"
                              className="form-control"
                              name="EndUserName"
                              autoComplete="off"
                              placeholder=""
                              as={FormikFormInput}
                              validcharacter={validCharacters}
                            />
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="kishu"
                              htmlFor="Kishu"
                            />
                            <Field
                              data-testid="Kishu"
                              className="form-control"
                              name="Kishu"
                              autoComplete="off"
                              placeholder=""
                              as={FormikFormInput}
                              validcharacter={validCharacters}
                            />
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="katashiki_1"
                              htmlFor="Katashiki1"
                            />
                            <Field
                              data-testid="Katashiki1"
                              className="form-control"
                              name="Katashiki1"
                              autoComplete="off"
                              placeholder=""
                              as={FormikFormInput}
                              validcharacter={validAllowedCharacters}
                            />
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="katashiki_2"
                              htmlFor="Katashiki2"
                            />
                            <Field
                              data-testid="Katashiki2"
                              className="form-control"
                              name="Katashiki2"
                              autoComplete="off"
                              placeholder=""
                              as={FormikFormInput}
                              validcharacter={validAllowedCharacters}
                            />
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="quantity"
                              htmlFor="Quantity"
                            />
                            <Field
                              data-testid="Quantity"
                              className="form-control"
                              name="Quantity"
                              autoComplete="off"
                              placeholder=""
                              as={FormikFormInput}
                            />
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="form-group">
                            {/* <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="next_process"
                              htmlFor="ProcessId"
                            /> */}
                            {/* <Field
                              data-testid="ProcessId"
                              className="form-control"
                              name="ProcessId"
                              autoComplete="off"
                              placeholder=""
                              as={FormikFormInput}
                              validcharacter={validAllowedCharacters}
                            /> */}
                            <div className="form-group">
                              <Label
                                className="label-style  col-form-label"
                                required={false}
                                label="next_process"
                                htmlFor="ProcessId"
                              />
                              <Field
                                data-testid="ProcessId"
                                className="form-control"
                                name="ProcessId"
                                autoComplete="off"
                                placeholder=""
                                as={FormikFormSelect}
                                options={props.allFactoryProcess}
                              />
                              {/* <Field
                              name="ProcessId"
                              as={FormikFormSelect}
                              options={props.allFactoryProcess}
                              className="form-control"
                            /> */}
                            </div>
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="form-group">
                            <Label
                              className="label-style col-form-label"
                              label="sub_contractor"
                            />
                            <Field
                              data-testid="testSubContractor"
                              className="form-control"
                              name="SubContractor"
                              type="number"
                              placeholder=""
                              as={FormikFormInput}
                            />
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="form-group">
                            <Label
                              className="label-style col-form-label"
                              label="material_product_id"
                              htmlFor="MaterialProductId"
                            />
                            <Field
                              data-testid="MaterialProductId"
                              className="form-control"
                              name="MaterialProductId"
                              autoComplete="off"
                              placeholder=""
                              as={FormikFormInput}
                              validcharacter={validCharacters}
                            />
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="form-group">
                            <Label
                              className="label-style col-form-label"
                              label="material_katashiki"
                              htmlFor="MaterialKatashiki"
                            />
                            <Field
                              data-testid="MaterialKatashiki"
                              className="form-control"
                              name="MaterialKatashiki"
                              autoComplete="off"
                              placeholder=""
                              as={FormikFormInput}
                              validcharacter={validCharacters}
                            />
                          </div>
                        </Col>
                      </Row>
                    </Form.Group>
                  </Dropdown.ItemText>
                  <Dropdown.Divider className="mb-0" />
                  <div className="d-flex filter-btn p-3 px-4 justify-content-between align-items-center">
                    <div style={{ visibility: props.isFilterCleared ? 'hidden' : 'visible' }}>
                      <Button
                        className="clear-filter float-end"
                        onClick={() => {
                          props.filterParmas(
                            OrderTableFilterInitialState,
                            true
                          );
                          resetForm();
                          setShowDropdown(false);
                          props.setIsFilterApplied(false);
                        }}
                      >
                        {formatMessage('clear_all_filters')}
                      </Button>
                    </div>
                    <Button
                      variant="secondary"
                      type="submit"
                      className=""
                      disabled={
                        JSON.stringify(props.initialValues) ===
                          JSON.stringify(values) ||
                        (!values.TrayId &&
                          !values.OrderId &&
                          !values.CustomerDueDate &&
                          !values.EUOrderNo &&
                          !values.ProductId &&
                          !values.EndUserName &&
                          !values.Kishu &&
                          !values.Katashiki1 &&
                          !values.Katashiki2 &&
                          !values.Quantity &&
                          !values.MaterialProductId &&
                          !values.MaterialKatashiki &&
                          (String(values.ProcessId) === '-3' ||
                            !values.ProcessId) &&
                          !values.SubContractor)
                      }
                    >
                      {formatMessage('apply')}
                    </Button>
                  </div>
                </Dropdown.Menu>
              </FormikForm>
            </Dropdown>
          );
        }}
      </Formik>
    </React.Fragment>
  );
};

export default FilterComponent;
